import { removeNull, resetAttribute } from '@/utils/handleData.js'

export default {
  namespaced: true,
  state: {
    projectNames: {}, // 缓存系统中所有工程项目
    projectList: {}, // 缓存工程项目列表当前页
    projectInfo: {} // 缓存查询到的单个工程项目详情信息
  },
  actions: {
    // 新建工程项目
    async addProject({ rootState, dispatch }, data) {
      const payload = Object.assign({}, data)
      if (
        rootState.currentStep &&
        rootState.currentStep.theme === 'buildProject' &&
        rootState.user.orgValue
      ) {
        payload.companyUid = rootState.user.orgValue
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/project/baseinfo',
          data: payload,
          msg: true
        },
        { root: true }
      )
      return res
    },
    // 删除工程项目
    async deleteProject({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/project/baseinfo',
          data: { uid: uid },
          msg: '删除工程项目成功'
        },
        { root: true }
      )
      return res
    },
    // 获取工程项目列表
    async getProjectList({ rootState, commit, dispatch }) {
      var queryValues = Object.assign({}, rootState.queryValues.project)
      queryValues.page = rootState.page.project
      queryValues.limit = rootState.limit.project
      if (
        rootState.currentStep &&
        rootState.currentStep.theme === 'buildProject'
      ) {
        queryValues.companyUid = rootState.user.orgValue
      } else {
        delete queryValues.companyUid
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/project/baseinfolist', data: queryValues },
        { root: true }
      )
      var projectList = res.data ? res.data : {}
      if (projectList.result && projectList.result.length) {
        projectList.result.forEach((item) => {
          if (item.isKey === '1') {
            item.isKey = '是'
          } else {
            item.isKey = '否'
          }
        })
      }
      commit(
        'baseSet',
        { module: 'project', key: 'projectList', value: projectList },
        { root: true }
      )
    },
    // 获取单个工程项目信息
    async getProjectInfo({ commit, dispatch }, uid) {
      var res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/project/baseinfodetail',
          data: { orgUid: uid }
        },
        { root: true }
      )
      var projectInfo = res.data ? res.data : {}
      const lng = projectInfo.xlon
      const lat = projectInfo.ylat
      projectInfo.uid = uid
      projectInfo.projectName = projectInfo.orgName
      projectInfo.projectLnglat =
        lng !== undefined && lng !== null && lng !== '' &&
        lat !== undefined && lat !== null && lat !== ''
          ? lng + ',' + lat
          : ''
      projectInfo.projectCoordinate = {}
      projectInfo.projectCoordinate.lng =
        lng !== undefined && lng !== null && lng !== '' ? lng : ''
      projectInfo.projectCoordinate.lat =
        lat !== undefined && lat !== null && lat !== '' ? lat : ''
      projectInfo.projectInfo = projectInfo.orgIntroduc
      commit(
        'baseSet',
        { module: 'project', key: 'projectInfo', value: projectInfo },
        { root: true }
      )
      return projectInfo
    },
    // 查询工程项目名称
    async getProjectName({ rootState, rootGetters, commit, dispatch }) {
      if (
        rootState.currentStep &&
        rootState.currentStep.theme === 'projectSection' &&
        rootGetters['user/orgType'] === 'bigPro' &&
        rootState.user.orgValue
      ) {
        const name = rootGetters['user/orgName']
        commit(
          'baseSet',
          {
            module: 'project',
            key: 'projectNames',
            value: [
              {
                label: name,
                value: rootState.user.orgValue,
                projectName: name,
                projectUid: rootState.user.orgValue
              }
            ]
          },
          { root: true }
        )
        return
      }
      const data = {}
      if (
        rootState.currentStep &&
        rootState.currentStep.theme === 'projectSection' &&
        rootGetters['user/orgType'] === 'com'
      ) {
        data.companyUid = rootState.user.orgValue
      }
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/project/projectnamelist', data: data },
        { root: true }
      )
      if (res.data && res.data !== {}) {
        const raw = Array.isArray(res.data)
          ? res.data
          : res.data.result && Array.isArray(res.data.result)
          ? res.data.result
          : []
        const projectNames = resetAttribute(
          raw,
          'projectName',
          'projectUid'
        )
        const formBase =
          (rootState.formValues && rootState.formValues.baseInfo) || {}
        const detail =
          (rootState.bidSection && rootState.bidSection.bidSectionBaseInfo) ||
          {}
        const selectedUid = formBase.projectUid || detail.projectUid
        const selectedName = formBase.projectName || detail.projectName
        if (
          selectedUid &&
          !projectNames.some((item) => item && String(item.value) === String(selectedUid))
        ) {
          projectNames.unshift({
            label: selectedName || selectedUid,
            value: selectedUid,
            projectName: selectedName || selectedUid,
            projectUid: selectedUid
          })
        }
        commit(
          'baseSet',
          { module: 'project', key: 'projectNames', value: projectNames },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'project', key: 'projectNames', value: [] },
          { root: true }
        )
      }
    },
    // 编辑工程项目
    async editProject({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/project/baseinfo',
          data: data,
          msg: '编辑工程项目成功'
        },
        { root: true }
      )
      return res
    }
  }
}
